angular.module('iqxCore')
.controller('actionDialogMakeAppointmentCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc, LanguageSvc) {
	$scope.selects={}
	$scope.selects.contacts=[]

	$scope.resetC=function(){
		$scope.companyContacts=undefined
		$scope.theRecord={}
		$scope.selects={}
		$scope.selects.contacts=[]
	}

	$scope.makeAppointment=function(){

		if(!$scope.theRecord.xDescription || $scope.theRecord.xDescription === ""){
			FormSvc.alert("Missing Description", "Please enter a description", "info")
		}else if(!$scope.theRecord.xDateFrom){
			FormSvc.alert("Missing Date", "Please enter a start date.", "info")
		}else if(!$scope.theRecord.xTimeFrom){
			FormSvc.alert("Missing Time", "Please enter a start time.", "info")
		}else if(!$scope.theRecord.xTimeTo && $scope.theRecord.xDateTo){ // if there is no end time but there is an end date require end time (if there is no end date and no end time it is a reminder)
			FormSvc.alert("Missing Time", "Please enter an end time.  If you are trying to create a reminder remove the end date.", "info")
		}else if(!$scope.theRecord.xDateTo && $scope.theRecord.xTimeTo){ // if there is no end date but there is an end time require end date (if there is no end date and no end time it is a reminder)
			FormSvc.alert("Missing Date", "Please enter an end date.  If you are trying to create a reminder remove the end time.", "info")
		}else{
			var newData={}
			newData.pAction='N'
			newData.pDescription=$scope.theRecord.xDescription
			newData.pStartDate=moment($scope.theRecord.xDateFrom).format('DD/MM/YYYY')
			newData.pStartTime=moment($scope.theRecord.xTimeFrom).format('HH:mm')

			if ($scope.theRecord.xPopupMinutes!=0 && $scope.theRecord.xPopupMinutes_checkbox) {
				newData.pMinutesBefore=$scope.theRecord.xPopupMinutes
			}

			if($scope.theRecord.xDateTo && $scope.theRecord.xTimeTo){
				newData.pEndDate=moment($scope.theRecord.xDateTo).format('DD/MM/YYYY')
				newData.pEndTime=moment($scope.theRecord.xTimeTo).format('HH:mm')
			}else{
				newData.pEndDate = undefined
				newData.pEndTime = undefined
			}


			if($scope.theRecord.xNotes){
				newData.pNotes=$scope.theRecord.xNotes
			}

			if($scope.actiondialogparams.type=="Person" || $scope.actiondialogparams.type=="Contact"){
				newData.pPersonID=$scope.actiondialogparams.linkID
			} else {
				newData.pEmploymentID=$scope.selects.contacts.Value
			}

			return $scope.exec('call/NetOwnerDiarySet',newData)
			.then(function(returnVal){
				if (returnVal) {
					FormSvc.alert("Appointment Created", LanguageSvc.lang.ActionDialog.createAppointment.successMessage, "success")
					$scope.resetC()
				}
			})
			.catch(function (err) {
				if (err && err!="escape key press") {ApplicationSvc.showMessage('Error',err,true)}
			})
		}
	}

	if ($scope.actiondialogparams.type=="Company") {
		//
			$scope.fetch({
					fetchAPI:'callresult/NetOwnerContactList?pCompanyID='+$scope.actiondialogparams.linkID,
					fetchTarget:'companyContacts',
					multiRow:true
			})
			.then(function(){
				$scope.tempC=$scope.companyContacts
				$scope.resetC()
				$scope.companyContacts=$scope.tempC
			})
	} else {
		$scope.resetC()
	}
})
